import { useEffect, useRef, useState } from "react";
import api from "../lib/api";

// Server clock offset cached in memory for the session.
// Positive value = server ahead of client; subtract from client Date.now().
let _serverOffsetMs = null;
let _fetching = null;

async function ensureServerOffset() {
  if (_serverOffsetMs !== null) return _serverOffsetMs;
  if (_fetching) return _fetching;
  _fetching = (async () => {
    try {
      const t0 = Date.now();
      const { data } = await api.get("/time");
      const t1 = Date.now();
      const rtt = t1 - t0;
      // adjust by half-RTT to approximate server-now at reception time
      _serverOffsetMs = data.now - (t0 + rtt / 2);
    } catch (e) {
      _serverOffsetMs = 0;
    }
    return _serverOffsetMs;
  })();
  return _fetching;
}

export default function Countdown({ endsAt, className = "", testId }) {
  const [now, setNow] = useState(Date.now());
  const offsetRef = useRef(0);
  useEffect(() => {
    let alive = true;
    ensureServerOffset().then((off) => { if (alive) offsetRef.current = off || 0; });
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  const end = new Date(endsAt).getTime();
  const diff = end - (now + offsetRef.current);
  if (isNaN(end)) return null;
  if (diff <= 0) {
    return <span className={`font-mono text-sm font-semibold text-slate-500 ${className}`} data-testid={testId}>Asta conclusa</span>;
  }
  const s = Math.floor(diff / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const parts = d > 0 ? [`${d}g`, `${h}h`, `${m}m`] : [`${String(h).padStart(2, "0")}h`, `${String(m).padStart(2, "0")}m`, `${String(sec).padStart(2, "0")}s`];
  const urgent = diff < 3600 * 1000;
  return (
    <span className={`font-mono text-sm font-semibold ${urgent ? "text-red-600 ga-tick" : "text-emerald-700"} ${className}`} data-testid={testId}>
      {parts.join(" : ")}
    </span>
  );
}
